import "@/assets/tailwind.css";
import "primeicons/primeicons.css";
import "primevue/resources/primevue.min.css";
import "primevue/resources/themes/lara-light-blue/theme.css";
import VNetworkGraph from "v-network-graph";
import "v-network-graph/lib/style.css";
import { createApp } from "vue";
import App from "./App.vue";
import "./app.scss";
import i18n from "./locale/locale.config";
import setComponent from "./modules/components.module";
import setIcons from "./modules/icons.module";
import setPrimeComponent from "./modules/prime.module";
import router from "./router";
import { MotionPlugin } from "@vueuse/motion";

export const app = createApp(App);
setPrimeComponent(app);
setComponent(app);
setIcons(app);
app.use(i18n);
app.use(router);
app.use(VNetworkGraph);
app.use(MotionPlugin);
app.mount("#app");
